/*
$(document).ready(function(){
  $('body').on('click', '.site-header__cart', function(e){
    if($(this).hasClass('re-active'))
    {
    	$(this).removeClass('re-active');
        $('.min-cart-section').css('transform', 'translateX(100%)');
        $('.min-cart').show();
        $('.min-cart-check').hide();
  	} else {
      	$(this).addClass('re-active');
    	$('.min-cart-section').css('transform', 'translateX(0)');
    }
    e.preventDefault();
  });

  $('.min-cart-section').on('click','.btnclose_mincart', function(){
    $('.site-header__cart').trigger('click');
  });

  $('.btnclose_mincart').click(function(){ });

   $('body').on('click', '.error_close', function(){
     $('.min_error').hide();
   });

   $('.min-cart-check').fadeOut(0);

  $('body').on('click', 'a.btnCartCheck', function(e){
    e.preventDefault();
    if (sessionStorage['compat_check'] != 'checked') {
      sessionStorage['compat_check'] = 'checked';
      //$('.min-cart').show();
      //$('.min-cart-check').hide();
      $('.min-cart-check').fadeOut(300);
    }
  });

    $('body').on('click', '.checkout_box a', function(e){

      if ($('input.iagree_input').prop("checked") == false){
    	  $('.min_error').show();
        e.preventDefault();
      } else if (sessionStorage['compat_check'] != 'checked') {
          //$('.min-cart').hide();
          //$('.min-cart-check').show();
          $('.min-cart-check').fadeIn(300);
          e.preventDefault();
      }
   });

  addToCartButton($(".product-page-form.product-form"));

  $('body').on('click', '.min_sg_box .cart__remove', function(e){

     e.preventDefault();

    	var line      = $(this).attr('data-line');
        jQuery.ajax({
          		  type: 'POST',
                  url: '/cart/change.js',
                  data: 'quantity=0&line=' + line,
                  dataType: 'json',
                  success: function(cart) {
                    if ((typeof callback) === 'function') {
                      callback(cart);
                    }
                  },
                  error: function(XMLHttpRequest, textStatus) {
                     alert('try again');
                  },
                  complete: function(jqxhr, text) {
                    update_cart();
                  }
        });

  });

  // checkout
  $('body').on('change', 'input[type="checkbox"].iagree_input', function(){
    if(this.checked) {
         $('.checkout_box').removeClass('checkout_disabled');
    }else
    {
       $('.checkout_box').addClass('checkout_disabled');
    }
  });

  // cart page
  $('input[type="submit"].cart__submit').click(function(){
    if($('.iaggray_btn').prop('checked')==false)
    {
      $('.min_error').show();
     	return false;
    }
  });

  // qty
  $('body').on('click', '.qty_box_custom .sign_min, .min_sg_box .sign_min', function(){

  //$('.cart__qty .sign_min').click(function(){
    var ct_qty = parseInt($(this).closest('.cart__qty').find('.cart__qty-input').val());
    if(ct_qty > 0)
    {
      ct_qty -=1;
     $(this).closest('.cart__qty').find('.cart__qty-input').val(ct_qty);
     updateQty($(this));
    }
  });
  
  $('body').on('click', '.qty_box_custom .sign_plus, .min_sg_box .sign_plus', function(){
    // $('.cart__qty .sign_plus').click(function(){
    var ct_qty = parseInt($(this).closest('.cart__qty').find('.cart__qty-input').val());
    ct_qty +=1;
    $(this).closest('.cart__qty').find('.cart__qty-input').val(ct_qty);
    updateQty($(this));


  });


});


function addToCartButton (wrapper) {

  wrapper.submit(function(e){
    if($(this).find('button[type="submit"]').hasClass('btn_disabled')) {
      return false;
    }
    e.preventDefault();
    jQuery.ajax({
      type: "POST",
      url: '/cart/add.js',
      //data: wrapper.find('form[action="/cart/add"]').serialize(),
      data: wrapper.serialize(),
      async: false,
      success: function(line_item){
        if ((typeof callback) === 'function') {
          callback(line_item, form);
        }
      },
      complete: function(jqxhr, text) {
        update_cart();

        if (wrapper.closest('.popup_full').length) {
          wrapper.closest('.popup_full').find(".li_info_close").trigger("click")

        }
       }
    });


  });
}

function updateQty (_which) {
  var line = _which.closest('.cart__qty').find('input[type="text"].cart__qty-input').attr('data-quantity-item');
		var quantity  = _which.closest('.cart__qty').find('input[type="text"].cart__qty-input').val();

    jQuery.ajax({
      type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        success: function(cart) {
          if ((typeof callback) === 'function') {

            callback(cart);
          }
        },
        error: function(XMLHttpRequest, textStatus) {
            alert('try again');
        },
        complete: function(jqxhr, text) {
          update_cart();
        }
    });
}



function update_cart()
{
     $.ajax({
           url: '/cart.js',
           dataType: "json",
           cache: false,
           success: function(cart) {
            if (!$('body').hasClass('template-cart')) {
              refreshCart(cart);
            } else {
              location.reload();
            }

         }
     });
}




function refreshCart(cart) {
    if(typeof BOLD === 'object' && BOLD.common && BOLD.common.cartDoctor && typeof BOLD.common.cartDoctor.fix === 'function'){
      cart = BOLD.common.cartDoctor.fix(cart);
    }

    let cartBtn = $(".site-header__cart");

    if (cartBtn) {
        var cartCount = cartBtn.find('.site-header__cart-count span');
        var cart_items_html = '<div class="min-cart-check">'+
        '<div><img src="https://cdn.shopify.com/s/files/1/0989/0116/t/19/assets/min-cart-logo.png?v=10970333477498524885" alt="Compatibility Check" />'+
            '<h2>COMPATIBILITY<br>CHECK</h2>'+
              '<h3>Many of our products are available in different versions for multiple apps.</h3>'+
              '<p>Before proceeding, please double-check you’ve added the correct version for your preferred app.</p>'+
              '<a href="#" class="btnCartCheck">OK, I’LL CHECK</a>'+
              '</div></div>';

        cart_items_html += '<div class="min-cart">'+
                      '<div class="close_option"> <div class="btnclose_mincart">close</div> </div>'+
              '<div class="min-cart-box">'+
                    '<div class="min-header">'+
                      '<div class="min-header-title">Your Cart </div>'+
                  '<div class="min-header-cart"><a href="/cart">View Cart</a></div>'+
                  '<div class="clearfix"></div>'+
              '</div>';
        var $cart = $(".min-cart-section");



        if ( cart.item_count == 0) {
          cart_items_html +=  '<p class="cart--empty-message">Your cart is currently empty.</p></div></div>';
        } else {

              $.each(cart.items, function(index, item) {

                var line_id = index +1 ;

                 var variantTitle = item.title.split('-');
				          var varientname ='';
              		for(var i=0;i<variantTitle.length;i++)
                    {
                      if(i!=0){
                        varientname += variantTitle[i];
                      }
                    }


                cart_items_html +=  '<div class="min_sg_box">'+
                  					   ' <div class="min_img_box">'+
               								'<img class="cart__image" src="'+item.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '')+'" alt="' + item.title + '">' +
           								' </div>'+
                    				    '<div class="min_sg_txt">'+

                                        '<div class="min_sg_title">'+
                                        '<a href="' + item.url + '">'+ variantTitle[0] +'</a>'+
                                        '</div>'+


                                        '<div class="cart__meta-text">'+
                                        varientname+ '<br/>'+
                                        '</div>';



              cart_items_html +=   '<div class="cart__qty">'+
                    			'<label for="updates_large_ " class="cart__qty-label">' + item.quantity + '</label>'+
                    '<div class="sign_min">-</div>'+
                    '<input class="cart__qty-input" type="text" name="updates[]" id="updates_large_ " value="'+item.quantity+'" min="0" pattern="[0-9]*" data-quantity-item="'+ line_id +'"/>'+
                    '<div class="sign_plus">+</div>'+
                  '</div>'+

                  '<div class="min_single_price">'+ Shopify.formatMoney(((!currencyEnabled) ? item.line_price : item.line_price/100 ), $cart.data('money-format')) +'</div>'+
           '</div>'+

           '<div class="min_remove">'+
            ' <a href="/cart/change?line='+ line_id +'&amp;quantity=0" class="cart__remove" data-line="'+line_id+'" >'+
            ' <img src="//cdn.shopify.com/s/files/1/0107/5865/1963/t/1/assets/Close_Button_2x.png" alt="remove"/>   '+            //   <img src="//cdn.shopify.com/s/files/1/0107/5865/1963/t/1/assets/close.png" alt="remove">
            ' </a>'+
          '</div>'+

          '<div class="clearfix"></div>'+
            '</div>';
            });

           cart_items_html +=  '</div><div class="min_cart_footer"> <div class="minc_subtotal">'+
             '<div class="subtotal_txt">Subtotal</div>'+
             '<div class="subtotal_price">' + Shopify.formatMoney(((!currencyEnabled) ? cart.total_price : cart.total_price/100 ), $cart.data('money-format')) +'  </div>'+
             '<div class="clearfix"></div> 	</div>'+

      	     '<div class="min_error">   <div class="min_error_inner">  <div class="error_close">'+
         	  '<img src="//cdn.shopify.com/s/files/1/0107/5865/1963/t/1/assets/Close_Error_Button_2x.png" alt="close"/>  '+

            '</div>'+
             '<div class="min_error_heading">ERROR! </div> <p>Please agree to the End User License Agreement</p>  </div> </div>'+

       	    '<div class="i_agree_box"> <label class="container min_btn_agree"><input type="checkbox" name="checkbox" class="iagree_input" /><span class="checkmark"></span></label>'+
            '<div class="min_text_agree">I agree to the <a href="#">End User License Agreement</a></div> </div>'+

      	    '<div class="checkout_box checkout_disabled" ><a href="/checkout">Go to Checkout </a>  </div>   </div>  </div></div>';

        }

            $cart.html('');
            $cart.append(cart_items_html);
            $cart.find('.min-cart-check').fadeOut(0);

           $('#CartCount').html('<span>'+cart.item_count+'</span>');

            //if (!$('body').hasClass('template-cart')) {
             $('.min-cart-section').css('transform', 'translateX(0)');
             $('.site-header__cart').addClass('active re-active');
           //  $('.min_cart_footer').css('bottom', '215px');
            //}
          if (currencyEnabled) updateCartCurrencies();
           $cart.fadeIn();

    }
}



 function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

*/
"use strict";